import { ContentContainer, Spinner } from '@ahc-digital/component-library';
import Script from 'next/script';
import { useState } from 'react';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { I06SparkleAppointment } from './I06SparkleAppointment.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: I06SparkleAppointment): JSX.Element => {
  const containerID =
    props?.params?.AnchorLinkTargetName ?? 'sparkle-appointment-booking-container';
  const [isError, setIsError] = useState(false);
  const [isJQueryLoaded, setIsJQueryLoaded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const context = useCustomSitecoreContext();
  const sparkleApiBaseUrl = context?.sparkleApiBaseUrl?.value;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <>
      <Script
        src="https://code.jquery.com/jquery-3.7.1.min.js"
        integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo="
        crossOrigin="anonymous"
        onError={() => setIsError(true)}
        onReady={() => setIsJQueryLoaded(true)}
      />
      {isJQueryLoaded && !isError && (
        <Script
          src={`${sparkleApiBaseUrl}/assets/embed/appointment_booking_wizard.js`}
          onError={() => {
            setIsError(true);
          }}
          onReady={() => {
            if (isError) return;

            // example expected url: https://www.myurl.org/appointment-slots/{sparkle-slot-id}/book
            const urlParts = window.location.pathname
              .split('/')
              .filter((part) => part && !part.startsWith('http'));
            if (urlParts.length < 3) return;

            const appointmentId = urlParts.at(-2);
            if (!appointmentId) return;

            new Sparkle.Embed.AppointmentBookingWizard(
              'sparkle-appointment-booking-container',
              appointmentId as string
            );
            setIsLoaded(true);
          }}
        />
      )}
      <div
        id={containerID}
        className={translationClasses(props?.params)}
        data-component={marketingRenderingName}
      >
        {!isError && !isLoaded && (
          <ContentContainer spacing="40-24">
            <Spinner />
          </ContentContainer>
        )}
        {isError && <></>}
        {isLoaded && <></>}
      </div>
    </>
  );
};
